import React, { PureComponent } from 'react';
import { css } from 'react-emotion';
import { colors } from '../../../css';
import { CustomBlock, ImageBlock, TextBlock } from './../../common';
import { ourVirtualExperts as content } from './../content';
import TunnelBridge from './../images/areas_of_expertise.jpg';
import Flow from './flow/flow.component';
import Steps from './steps/steps.component';

export default class Industries extends PureComponent {
    constructor() {
        super();
    }

    render() {
        return (
            <div>
                <section key="ourVirtualExperts" className={s.wrapper}>
                    <TextBlock
                        {...{
                            heading: content.virtualExperts.heading,
                            text: content.virtualExperts.content,
                            id: 'ourVirtualExperts',
                            backgroundColor: colors.cyan,
                            order: 1,
                            color: colors.blue,
                        }}
                    />
                    <CustomBlock
                        {...{
                            component: <Steps />,
                            backgroundColor: colors.cyan,
                            order: 2,
                        }}
                    />
                </section>
                <section key="controlAndScalability" className={s.wrapper}>
                    <TextBlock
                        {...{
                            heading: content.transparent.heading,
                            order: 1,
                            tinyHeading: true,
                            text: content.transparent.content,
                            backgroundColor: colors.white,
                            color: colors.blue,
                            left: true,
                        }}
                    />
                    <CustomBlock
                        {...{
                            overrideWidth: true,
                            component: <Flow />,
                            backgroundColor: colors.white,
                            order: 2,
                        }}
                    />
                </section>
                <section key="transparencyAndAutomation" className={s.wrapper}>
                    <TextBlock
                        {...{
                            heading: (
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: content.scalability.heading,
                                    }}
                                />
                            ),
                            tinyHeading: true,
                            text: content.scalability.content,
                            backgroundColor: colors.blue,
                            color: colors.white,
                        }}
                    />
                    <TextBlock
                        {...{
                            heading: content.control.heading,
                            tinyHeading: true,
                            text: content.control.content,
                            backgroundColor: colors.blue,
                            color: colors.white,
                            left: false,
                        }}
                    />
                </section>
                <section key="areasOfExpertise" className={s.wrapper}>
                    <ImageBlock
                        {...{
                            backgroundColor: colors.cyan,
                            image: TunnelBridge,
                            order: 4,
                        }}
                    />
                    <TextBlock
                        {...{
                            heading: content.areas.heading,
                            id: 'areasOfExpertise',
                            text: content.areas.content,
                            backgroundColor: colors.cyan,
                            color: colors.blue,
                            left: false,
                            order: 3,
                        }}
                    />
                </section>
            </div>
        );
    }
}

const s = {};

s.wrapper = css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
`;



// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/ourVirtualExperts.component.js